import React, { useState, forwardRef } from 'react';
import { styled } from '@mui/material';
import omit from 'lodash-es/omit';
import clsx from 'clsx';
import { IconEyeClose, IconEyeOpen } from '../../internal/icons';
import { getStyle, passwordClasses } from './style';
import Input from './Input';
import { Button } from '../../Button';
import { useTranslation } from '../../hooks/useTranslation';
const defaultIconRender = (visible) => visible ? React.createElement(IconEyeClose, null) : React.createElement(IconEyeOpen, null);
const PasswordBase = forwardRef((props, ref) => {
    const { visible, onVisibleChange, iconRender = defaultIconRender, disabled, ...rest } = props;
    const { t } = useTranslation('Input');
    const visibilityControlled = typeof visible !== 'undefined';
    const [innerVisible, setInnerVisible] = useState(() => visibilityControlled ? visible : false);
    const handleVisibleChange = () => {
        // When the Button is set to disabled, the onClick event will not be triggered, so ignore it here.
        // istanbul ignore next
        if (disabled) {
            return;
        }
        setInnerVisible((prevState) => {
            const newState = !prevState;
            onVisibleChange?.(newState);
            return newState;
        });
    };
    const getIcon = () => {
        const icon = iconRender(innerVisible);
        return (React.createElement(Button, { variant: "icon", type: "tertiary", size: "small", onClick: handleVisibleChange, className: `${passwordClasses.visibleIcon}`, disabled: disabled, tabIndex: disabled ? -1 : 0, "aria-label": innerVisible ? t('hidePassword') : t('showPassword'), key: "passwordIcon", onMouseDown: (e) => {
                e.preventDefault();
            }, onMouseUp: (e) => {
                e.preventDefault();
            } }, icon));
    };
    return (React.createElement(Input, { suffix: getIcon(), type: innerVisible ? 'text' : 'password', disabled: disabled, ...rest, ref: ref, className: clsx(rest.className, passwordClasses.password) }));
});
const StyledPassword = styled(PasswordBase)((props) => {
    const { theme, disabled, readOnly, status, prefix, suffix, allowClear, size, } = props;
    const shouldRenderAffix = !!prefix || !!suffix || !!allowClear;
    return getStyle(theme, {
        disabled,
        readOnly,
        status,
        size,
        shouldRenderAffix,
    });
});
const RefPassword = React.forwardRef((props, ref) => (React.createElement(StyledPassword, { ...props, ref: ref })));
//  The exposed components must support the use of ref.
const Password = React.forwardRef((props, ref) => {
    const internalProps = omit(props, ['style']);
    return React.createElement(RefPassword, { ...internalProps, ref: ref });
});
export default Password;
